import { IDepositInfoVerifier } from './IDepositInfoVerifier'

export const depositAmountVerifier: IDepositInfoVerifier = {
  verify: async (deposit, chainDepositConfig) => {
    const { depositAmountGwei } = chainDepositConfig
    return deposit.amount !== depositAmountGwei
  },
}
